import { isRealUserSchedule, isSessionRound, DEFAULT_SCHEDULE_ORDER_BY } from 'common-data-handling';
import { sortBy, uniqBy } from 'lodash';
import { useMemo } from 'react';
import { useEventSchedule } from '../useEventSchedule';

/**
 * Returns all the sessions that are part of the user selection (plenary + selected sessions)
 * @param {number} eventId
 * @param {function} filter Filter to be applied to every item
 * @param {string} orderBy Sort configuration
 * @returns {array}
 */
export function useUserSchedule(eventId, { filter, orderBy = DEFAULT_SCHEDULE_ORDER_BY, includeParentRounds = false, includeAllRoundSessions = false } = {}) {
    const schedule = useEventSchedule(eventId);

    return useMemo(() => {
        let result = schedule.filter(isRealUserSchedule);

        if (includeParentRounds) {
            const allRounds = schedule.filter(isSessionRound),
                rounds = result
                    .filter((s) => s.round_id)
                    .map((s) => allRounds.find((r) => r.id == s.round_id))
                    .filter(Boolean);
            result = [...result, ...rounds];
        }
        if (includeAllRoundSessions) {
            const sessionsInRounds = schedule.filter(isSessionRound).map((round) => schedule.filter((s) => s.round_id == round.id));
            result = [...result, ...sessionsInRounds].flat(2);
        }

        result = uniqBy(result, 'id');

        if (filter) result = result.filter(filter);
        if (orderBy) result = sortBy(result, orderBy);

        return result;
    }, [schedule, filter, orderBy]);
}
